import { mapActions } from 'vuex';
const docViewer_mixins = {       
    methods: {
        ...mapActions('docViewer_store', ['ACT_docViewer']),
        MIX_docViewer (payload){
            this.ACT_docViewer(payload);
        },
    }
}
export default {
    install (Vue, options) {
        Vue.mixin(docViewer_mixins)
    }
};  
  